import Decimal from 'decimal.js'
import kendo from '@progress/kendo-ui'
import extendFunctions from './extend.js'
var cellref = require('cellref')

export default {
  // 将单元格Json转换为A1:A1
  ConvertJsonToRange: function (JsonStyle) {
    return this.ConvertJsonToA1(JsonStyle.topLeft) + ':' + this.ConvertJsonToA1(JsonStyle.bottomRight)
  },

  // 将单元格Json转换为A1
  ConvertJsonToA1: function (JsonStyle) {
    var row = JsonStyle.row
    var column = JsonStyle.col
    var columnStr = ''
    for (; column; column = Math.floor((column - 1) / 26)) {
      columnStr = String.fromCharCode(((column - 1) % 26) + 65) + columnStr
    }
    return columnStr + row
  },
  convertA1ToJson(cellA1, workSheet) {
    var sectionArray = cellA1.toUpperCase().replace(/\$/g, '').split(':')
    return {
      topLeft: this.convertCellFormat(sectionArray[0]),
      bottomRight: this.convertCellFormat(sectionArray[1]),
      workSheet: workSheet
    }
  },
  // 单元格格式转换，将A1格式转为一个单元格的Json对象
  convertCellFormat(cell_A1, type) {
    if (cell_A1 === '') { return }
    var cell_RC = cellref.toR1C1(cell_A1)
    var sectionArray = cell_RC.substring(1).split('C')
    return {
      row: parseInt(sectionArray[0]),
      col: parseInt(sectionArray[1])
    }
  },
  // 将this.spreadSheet标准格式转换为标准Json区域格式
  ConvertAllFormat2Json: function (obj, owner) {
    var output = []
    var rangeJson = {}
    var i
    if (obj !== undefined) {
      if (obj instanceof kendo.spreadsheet.UnionRef) {
        // 判断是UnionRef
        for (i = 0; i < obj.length; i++) {
          output.push(this.ConvertAllFormat2Json(obj.refs[i]), owner)
        }
        return output
      } else if (obj instanceof kendo.spreadsheet.RangeRef) {
        // 判断不是RangeRef
        // console.log(obj)
        if (obj.sheet !== undefined && obj.sheet !== null && obj.sheet !== '') { rangeJson.workSheet = obj.sheet } else { rangeJson.workSheet = owner.activeSheet }
        rangeJson.topLeft = {}
        rangeJson.topLeft.row = obj.topLeft.row + 1
        rangeJson.topLeft.col = obj.topLeft.col + 1
        rangeJson.bottomRight = {}
        rangeJson.bottomRight.row = obj.bottomRight.row + 1
        rangeJson.bottomRight.col = obj.bottomRight.col + 1
        return rangeJson
      } else if (obj instanceof kendo.spreadsheet.CellRef) {
        // 判断是不是CellRef
        if (obj.sheet !== undefined && obj.sheet !== null && obj.sheet !== '') { rangeJson.workSheet = obj.sheet } else { rangeJson.workSheet = owner.activeSheet }
        rangeJson.topLeft = {}
        rangeJson.topLeft.row = obj.row + 1
        rangeJson.topLeft.col = obj.col + 1
        rangeJson.bottomRight = {}
        rangeJson.bottomRight.row = obj.row + 1
        rangeJson.bottomRight.col = obj.col + 1
        return rangeJson
      } else if (obj.length !== undefined) {
        // 判断是UnionRef
        for (i = 0; i < obj.length; i++) {
          output.push(this.ConvertAllFormat2Json(obj.refs[i]))
        }
        return output
      } else if (obj.topLeft !== undefined) {
        // 判断不是RangeRef
        // console.log(obj)
        if (obj.sheet !== undefined && obj.sheet !== null && obj.sheet !== '') { rangeJson.workSheet = obj.sheet } else { rangeJson.workSheet = owner.activeSheet }
        rangeJson.topLeft = {}
        rangeJson.topLeft.row = obj.topLeft.row + 1
        rangeJson.topLeft.col = obj.topLeft.col + 1
        rangeJson.bottomRight = {}
        rangeJson.bottomRight.row = obj.bottomRight.row + 1
        rangeJson.bottomRight.col = obj.bottomRight.col + 1
        return rangeJson
      } else if (obj.row !== undefined) {
        // 判断是不是CellRef
        if (obj.sheet !== undefined && obj.sheet !== null && obj.sheet !== '') { rangeJson.workSheet = obj.sheet } else { rangeJson.workSheet = owner.activeSheet }
        rangeJson.topLeft = {}
        rangeJson.topLeft.row = obj.row + 1
        rangeJson.topLeft.col = obj.col + 1
        rangeJson.bottomRight = {}
        rangeJson.bottomRight.row = obj.row + 1
        rangeJson.bottomRight.col = obj.col + 1
        return rangeJson
      }
    }
    extendFunctions.errorMessage('字段转换失败！', '字段转换失败！')
    return undefined
  },

  // 将二维数组转置
  TransArray: function (originArray) {
    return originArray[0].map(function (col, i) {
      return originArray.map(function (row) {
        return row[i]
      })
    })
  },

  // 根据baseType返回合法的值
  // source 1=控件 其他=表格
  GetValidValue: function (value, baseType, length, scale, dateFormat, source) {
    var tempValue
    switch (baseType) {
      case 1:
        // 字符串
        if (value === null || value === '') {
          return this.GetValidNullValue(baseType)
        }
        // 过滤字符串最后的/r
        value = value.toString()
        if (escape(value.substr(-1)) === '%0D') {
          value = value.substring(0, value.length - 1)
        }
        if (value.length > length / 2) {
          return '$max_length$'
        } else {
          return value
        }
      case 3:
        // 数值
        if (!value) {
          return this.GetValidNullValue(baseType)
        }
        var reg = /^[-+]?[0-9]+.?[0-9]*$/
        if (reg.test(value)) {
          tempValue = (new Decimal(value)).toDP(scale)
          if (tempValue.precision() > length + scale) {
            // 数值长度超限
            return -2147483647
          }
          return parseFloat(tempValue)
        } else {
          // 不合法的数值
          return -2147483648
        }
      case 4:
        // 日期
        if (!value) {
          return this.GetValidNullValue(baseType)
        }
        tempValue = this.StringNumToDate(value, source)
        if (isNaN(tempValue.getFullYear())) {
          return 'error'
        }
        if (dateFormat) {
          // new Date(tempValue.valueOf() + 60 * 60 * 8000).toISOString()
          return tempValue.toJSON().substr(0, 19).replace('T', ' ').replace(new RegExp('-', 'g'), '/')
        } else {
          // '1900-01-01T00:00:00Z'格式
          tempValue.setHours(tempValue.getHours() - 8)
          return this.ConvertDateTime('yyyy-MM-ddThh:mm:ssZ', tempValue)
        }
      case 5:
      case 6:
        // 图片5附件6
        if (!value) {
          return this.GetValidNullValue(baseType)
        }
        if (typeof value === 'string') {
          try {
            value = JSON.parse(value)
          } catch (ex) {
            return this.GetValidNullValue(baseType)
          }
        }
        if (!value.data.length) {
          return this.GetValidNullValue(baseType)
        }
        return JSON.stringify(value)
      default:
        if (!value || !value.data.length) {
          return this.GetValidNullValue(baseType)
        }
        return value.toString()
    }
  },

  // 根据baseType返回合法的空值
  GetValidNullValue: function (baseType) {
    switch (baseType) {
      case 1:
        // 字符串
        return ''
      case 3:
        // 数值
        return 0
      case 4:
        // 日期
        return null
      case 5:
        // 图片
        return ''
      case 6:
        // 附件
        return ''
      default:
        return ''
    }
  },

  // 根据baseType返回合法的值
  SetValidValue(baseType, value, owner) {
    if (value === null || value === undefined) {
      return null
    }
    switch (baseType) {
      case 3:
        if (value === 0 || value === '') {
          return owner.zeroModel ? 0 : null
        }
        break
      case 4:
        if (value) {
          value = this.ConvertAll2ExcelNum(value)
          // if (value < 3) {
          //   return null
          // }
          if (value === 2) {
            return null
          }
          return value
        } else {
          return null
        }
      case 5:
      case 6:
        if (!value) {
          return {
            data: []
          }
        }
        break
      default:
        if (!value) {
          return null
        }
        break
    }
    return value
  },

  ConvertDateTime(fmt, date) {
    var o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      'S': date.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length)) }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
    }
    return fmt
  },

  // 日期类型转为excel数值型日期
  ConvertAll2ExcelNum(date) {
    var tempDate = this.StringNumToDate(date instanceof String ? date.trim() : date)
    // var noteDate = new Date(1900, 1, 29)
    // 由于Excel在判断1900-2-29存在BUG，此处为了保持与excel一致，单独进行了处理
    // if (tempDate <= noteDate) {
    //   tempDate.setDate(tempDate.getDate() + 1)
    // }
    return this.dateToSerial(tempDate)
    // return this.DateToNumber(tempDate)
  },

  // 字符串或数值转日期
  StringNumToDate: function (excelDate, source) {
    try {
      if (isNaN(excelDate)) {
        excelDate = excelDate.replace('T', ' ')
        excelDate = excelDate.replace('Z', '')
        if (source) {
          return new Date(new Date(excelDate.replace(/-/g, '/')).valueOf() + 60 * 60 * 8000) || new Date(new Date(excelDate.replace(/-/g, '/') + ' ').valueOf() + 60 * 60 * 8000)
        } else {
          return new Date(excelDate.replace(/-/g, '/')) || new Date(excelDate.replace(/-/g, '/') + ' ')
        }
      } else {
        return this.serialToDate(excelDate)
        // return new Date((new Decimal(excelDate).sub(new Decimal(25569)).mul(new Decimal(86400000))).toNumber())
      }
    } catch (ex) {
      return new Date()
    }
  },

  // 将Excel数值形式日期转为Date对象
  DateToNumber: function (JSDate) {
    var D = new Date(JSDate)
    var Null = new Date(Date.UTC(1899, 11, 30, 0, 0, 0, 0))
    return Decimal.round((((D.getTime() - Null.getTime()) / 60000 - D.getTimezoneOffset()) / 1440) * 1000000) / 1000000
  },

  dateFormat: function (date, fmt) {
    date.setHours(date.getHours() - 8)
    var o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      'S': date.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length)) }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
    }
    return fmt
  },
  unpackDate: function (serial) {
    return this.julianDaysToDate((serial | 0) + this.dateToJulianDays(1900, 0, -1))
  },

  packDate: function (year, month, date) {
    return this.dateToJulianDays(year, month, date) - this.dateToJulianDays(1900, 0, -1)
  },

  dateToJulianDays: function (y, m, d) {
    m++
    return ((1461 * (y + 4800 + ((m - 14) / 12 | 0))) / 4 | 0) +
      ((367 * (m - 2 - 12 * ((m - 14) / 12 | 0))) / 12 | 0) -
      ((3 * (((y + 4900 + ((m - 14) / 12 | 0)) / 100 | 0))) / 4 | 0) +
      d - 32075
  },

  isLeapYear: function (yr) {
    if (yr % 4) {
      return 0
    }
    if (yr % 100) {
      return 1
    }
    if (yr % 400) {
      return 0
    }
    return 1
  },
  julianDaysToDate: function (jd) {
    var ORDINAL_ADD_DAYS = [
      [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], // non-leap year
      [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335] // leap year
    ]
    var l, n, j, i, m, d, y
    l = jd + 68569
    n = (4 * l) / 146097 | 0
    l = l - ((146097 * n + 3) / 4 | 0)
    i = (4000 * (l + 1) / 1461001) | 0
    l = l - ((1461 * i) / 4 | 0) + 31
    j = (80 * l) / 2447 | 0
    d = l - ((2447 * j) / 80 | 0)
    l = j / 11 | 0
    m = j + 2 - (12 * l)
    y = 100 * (n - 49) + i + l
    m--
    return {
      year: y,
      month: m,
      date: d,
      day: (jd + 1) % 7,
      ord: ORDINAL_ADD_DAYS[this.isLeapYear(y)][m] + d
    }
  },

  unpackTime: function (serial) {
    var MS_IN_MIN = 60 * 1000
    var MS_IN_HOUR = 60 * MS_IN_MIN
    var MS_IN_DAY = 24 * MS_IN_HOUR
    var frac = serial - (serial | 0)
    if (frac < 0) {
      frac++
    }
    var ms = Math.round(MS_IN_DAY * frac)
    var hours = Math.floor(ms / MS_IN_HOUR)
    ms -= hours * MS_IN_HOUR
    var minutes = Math.floor(ms / MS_IN_MIN)
    ms -= minutes * MS_IN_MIN
    var seconds = Math.floor(ms / 1000)
    ms -= seconds * 1000
    return {
      hours: hours,
      minutes: minutes,
      seconds: seconds,
      milliseconds: ms
    }
  },

  serialToDate: function (serial) {
    var d = this.unpackDate(serial)
    var t = this.unpackTime(serial)
    return new Date(d.year, d.month, d.date,
      t.hours + 8, t.minutes, t.seconds, t.milliseconds)
  },

  packTime: function (hh, mm, ss, ms) {
    return (hh + (mm + (ss + ms / 1000) / 60) / 60) / 24
  },

  dateToSerial: function (date) {
    var time = this.packTime(date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      date.getMilliseconds())
    date = this.packDate(date.getFullYear(),
      date.getMonth(),
      date.getDate())
    if (date < 0) {
      return date - 1 + time
    } else {
      return date + time
    }
  },

  base64ToBlob(file) {
    try {
      var arr = file.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    } catch (exception) {
      console.log(exception)
      return null
    }
  },
  /**
 * Created by Wandergis on 2015/7/8.
 * 提供了百度坐标（BD09）、国测局坐标（火星坐标，GCJ02）、和WGS84坐标系之间的转换
 */

  // 定义一些常量
  x_PI: 3.14159265358979324 * 3000.0 / 180.0,
  PI: 3.1415926535897932384626,
  a: 6378245.0,
  ee: 0.00669342162296594323,

  /**
   * 百度坐标系 (BD-09) 与 火星坐标系 (GCJ-02)的转换
   * 即 百度 转 谷歌、高德
   * @param bd_lon
   * @param bd_lat
   * @returns {*[]}
   */
  bd09togcj02(bd_lon, bd_lat) {
    var x_pi = 3.14159265358979324 * 3000.0 / 180.0
    var x = bd_lon - 0.0065
    var y = bd_lat - 0.006
    var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi)
    var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi)
    var gg_lng = z * Math.cos(theta)
    var gg_lat = z * Math.sin(theta)
    return [gg_lng, gg_lat]
  },

  /**
   * 火星坐标系 (GCJ-02) 与百度坐标系 (BD-09) 的转换
   * 即谷歌、高德 转 百度
   * @param lng
   * @param lat
   * @returns {*[]}
   */
  gcj02tobd09(lng, lat) {
    var z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * this.x_PI)
    var theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * this.x_PI)
    var bd_lng = z * Math.cos(theta) + 0.0065
    var bd_lat = z * Math.sin(theta) + 0.006
    return [bd_lng, bd_lat]
  },

  /**
   * WGS84转GCj02
   * @param lng
   * @param lat
   * @returns {*[]}
   */
  wgs84togcj02(lng, lat) {
    if (this.out_of_china(lng, lat)) {
      return [lng, lat]
    } else {
      var dlat = this.transformlat(lng - 105.0, lat - 35.0)
      var dlng = this.transformlng(lng - 105.0, lat - 35.0)
      var radlat = lat / 180.0 * this.PI
      var magic = Math.sin(radlat)
      magic = 1 - this.ee * magic * magic
      var sqrtmagic = Math.sqrt(magic)
      dlat = (dlat * 180.0) / ((this.a * (1 - this.ee)) / (magic * sqrtmagic) * this.PI)
      dlng = (dlng * 180.0) / (this.a / sqrtmagic * Math.cos(radlat) * this.PI)
      var mglat = lat + dlat
      var mglng = lng + dlng
      return [mglng, mglat]
    }
  },

  /**
   * GCJ02 转换为 WGS84
   * @param lng
   * @param lat
   * @returns {*[]}
   */
  gcj02towgs84(lng, lat) {
    if (this.out_of_china(lng, lat)) {
      return [lng, lat]
    } else {
      var dlat = this.transformlat(lng - 105.0, lat - 35.0)
      var dlng = this.transformlng(lng - 105.0, lat - 35.0)
      var radlat = lat / 180.0 * this.PI
      var magic = Math.sin(radlat)
      magic = 1 - this.ee * magic * magic
      var sqrtmagic = Math.sqrt(magic)
      dlat = (dlat * 180.0) / ((this.a * (1 - this.ee)) / (magic * sqrtmagic) * this.PI)
      dlng = (dlng * 180.0) / (this.a / sqrtmagic * Math.cos(radlat) * this.PI)
      var mglat = lat + dlat
      var mglng = lng + dlng
      return [lng * 2 - mglng, lat * 2 - mglat]
    }
  },

  transformlat(lng, lat) {
    var ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng))
    ret += (20.0 * Math.sin(6.0 * lng * this.PI) + 20.0 * Math.sin(2.0 * lng * this.PI)) * 2.0 / 3.0
    ret += (20.0 * Math.sin(lat * this.PI) + 40.0 * Math.sin(lat / 3.0 * this.PI)) * 2.0 / 3.0
    ret += (160.0 * Math.sin(lat / 12.0 * this.PI) + 320 * Math.sin(lat * this.PI / 30.0)) * 2.0 / 3.0
    return ret
  },

  transformlng(lng, lat) {
    var ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng))
    ret += (20.0 * Math.sin(6.0 * lng * this.PI) + 20.0 * Math.sin(2.0 * lng * this.PI)) * 2.0 / 3.0
    ret += (20.0 * Math.sin(lng * this.PI) + 40.0 * Math.sin(lng / 3.0 * this.PI)) * 2.0 / 3.0
    ret += (150.0 * Math.sin(lng / 12.0 * this.PI) + 300.0 * Math.sin(lng / 30.0 * this.PI)) * 2.0 / 3.0
    return ret
  },

  /**
   * 判断是否在国内，不在国内则不做偏移
   * @param lng
   * @param lat
   * @returns {boolean}
   */
  out_of_china(lng, lat) {
    return (lng < 72.004 || lng > 137.8347) || ((lat < 0.8293 || lat > 55.8271) || false)
  },
  bd09towgs84(lng, lat) {
    var gcj02 = this.bd09togcj02(lng, lat)
    return this.gcj02towgs84(gcj02[0], gcj02[1])
  },
  wgs84tobd09(lng, lat) {
    var gcj02 = this.wgs84togcj02(lng, lat)
    return this.gcj02tobd09(gcj02[0], gcj02[1])
  }
}
